<template>
  <ContentLayout
    :title="$t('label_essweb_approvalTemplate_form_newTitle')"
    pad="0"
    widthClass="max-1000"
    :initData="approvalData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'flow_template_status',
      'flow_template_name',
      'flow_template_description',
      'flow_type_uuid',
      'flow_template_code',
      'business_data_table_name',
      'effective_utc_datetime',
      'expired_utc_datetime',
      'remarks',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Stepper :curStep="curStep" :items="stepper">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row>
              <!-- 
请检查一下所有新增页面 不需要填状态，默认都是‘有效的’ brain bug1743 -->
              <!-- <v-col
                xs="12"
                sm="12"
                md="12"
                lg="12"
                cols="12"
                class="pt-0 pb-0"
              >
                <v-switch
                  color="primary"
                  class="ml-4"
                  v-model="approvalData.flow_template_status"
                  :label="
                    approvalData.flow_template_status
                      ? $t('label_essweb_approvalTemplate_form_activeLabel')
                      : ''
                  "
                ></v-switch>
              </v-col> -->
              <v-col xs="12" sm="12" md="8" lg="8" cols="12">
                <inputTextFiledMultiLang
                  :bindData="approvalData.flow_template_name"
                  maxlength="100"
                  @change="
                    (valueArr) => {
                      approvalData.flow_template_name = valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_approvalTemplate_form_approvalTemplateNameLabel'
                    )
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="4" lg="4" cols="12">
                <normalInputTextFiled
                  :label="$t('label_essweb_ClaimReason_form_codeLabel')"
                  maxlength="100"
                  :rules="
                    $GetRules(['_Require_Rules', '_Length_Rules'], [null, 100])
                  "
                  v-model="approvalData.flow_template_code"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :bindData="approvalData.flow_template_description"
                  maxlength="500"
                  @change="
                    (valueArr) => {
                      approvalData.flow_template_description = valueArr;
                    }
                  "
                  :label="
                    $t('label_essweb_approvalTemplate_form_descriptionLabel')
                  "
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t(
                    "label_essweb_approvalTemplate_form_approvalTemplateTypeLabel"
                  )
                }}</v-sheet>
                <v-autocomplete
                  :items="approvalType"
                  item-text="flow_type_name"
                  item-value="uuid"
                  single-line
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  v-model="approvalData.flow_type_uuid"
                  filled
                  :label="
                    $t(
                      'label_essweb_approvalTemplate_form_approvalTemplateTypeLabel'
                    )
                  "
                  dense
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-autocomplete>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_approvalTemplate_form_tableNameLabel")
                }}</v-sheet>
                <v-autocomplete
                  single-line
                  dense
                  :readonly="NodeList.length > 0 ? true : false"
                  v-model="approvalData.business_data_table_name"
                  filled
                  item-text="view_fields"
                  item-value="value_field"
                  :placeholder="
                    $t('label_essweb_approvalTemplate_form_tableNameLabel')
                  "
                  :items="Tables"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                >
                  <template v-slot:no-data> <noContent /> </template>
                  <template v-slot:selection="data">
                    {{ $getCommonLangValue(data.item.view_fields) }}
                  </template>
                  <template v-slot:item="data">
                    <div class="table-title text--primary">
                      {{ $getCommonLangValue(data.item.view_fields) }}
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <DateTimePicker
                  type="date"
                  :label="
                    $t('label_essweb_approvalTemplate_form_effectiveDateLabel')
                  "
                  placeholder="YYYY/MM/DD"
                  :defaultTime="approvalData.effective_utc_datetime"
                  :max="approvalData.expired_utc_datetime"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  @change="
                    (time) => {
                      approvalData.effective_utc_datetime = time;
                    }
                  "
                />
              </v-col>
              <!-- <v-col  xs='12' sm="6" md='6' lg='6' cols="12">
                Time Zone:
                <v-select
                  single-line
                  dense
                  v-model="approvalData.effective_time_zone"
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  filled
                  :items="staticZone"
                  item-text="text"
                  item-value="utc"
                >
          <template v-slot:no-data>
            <noContent />
          </template></v-select>
              </v-col>-->
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <DateTimePicker
                  :min="approvalData.effective_utc_datetime"
                  type="date"
                  placeholder="YYYY/MM/DD"
                  :defaultTime="approvalData.expired_utc_datetime"
                  :label="
                    $t('label_essweb_approvalTemplate_form_expireDateLabel')
                  "
                  @change="
                    (time) => {
                      approvalData.expired_utc_datetime = time;
                    }
                  "
                />
              </v-col>
              <!-- <v-col md="4">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_approvalTemplate_form_timeZoneLabel")
                }}</v-sheet>
                <v-select
                  single-line
                  v-model="approvalData.expired_time_zone"
                  dense
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  filled
                  :items="staticZone"
                  item-text="text"
                  item-value="utc"
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-select>
              </v-col> -->
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_approvalTemplate_form_remarkLabel")
                }}</v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  maxlength="500"
                  v-model="approvalData.remarks"
                  dense
                  counter="500"
                  single-line
                  filled
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <!-- <noContent v-if="NodeList.length == 0" /> -->
          <draggable
            v-model="dragArr"
            draggable=".drag"
            v-bind="{ animation: 1000 }"
          >
            <!-- :list="NodeList" -->
            <v-sheet
              class="drag transparent d-flex flex-grow-1 ma-3 align-center"
              v-for="(item, index) in NodeList"
              :key="index"
            >
              <v-avatar color="primary  white--text" size="40">
                <span class="headline">
                  {{ item.number === undefined ? index + 1 : item.number + 1 }}
                </span>
              </v-avatar>
              <v-hover v-slot:default="{ hover }" open-delay="100">
                <v-card
                  class="
                    white
                    d-flex
                    flex-row
                    justify-space-around
                    flex-grow-1
                    ml-3
                    pa-2
                    align-center
                  "
                  :elevation="hover ? 10 : 2"
                >
                  <!--  buglist 1495 -->
                  <!-- <div>
                    <svg-icon size="36" fill="grey" iconClass="dragvertical" />
                  </div> -->
                  <span>
                    {{ $getCommonLangValue(item.flow_template_node_name) }}
                  </span>
                  <v-spacer></v-spacer>
                  <div>
                    <v-btn
                      icon
                      x-small
                      class="ma-2"
                      @click="toEditNode(item, index)"
                    >
                      <span class="material-icons-round">edit</span>
                    </v-btn>
                    <v-btn icon class="ma-2" @click="toDeleteNode(item)">
                      <span class="material-icons-round">delete</span>
                    </v-btn>
                  </div>
                </v-card>
              </v-hover>
            </v-sheet>
            <v-btn
              text
              slot="footer"
              color="primary"
              small
              @click="showNewApprovalDialog = true"
              class="text-capitalize"
            >
              <span class="material-icons-round">add</span
              >{{
                $t("label_essweb_approvalTemplate_form_node_addNodeBtnLabel")
              }}
            </v-btn>
          </draggable>
        </template>
      </Stepper>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        :newBtn="step == curStep && curStep != 0 ? true : false"
        :step="step == curStep ? false : true"
        @next="toNext"
        :preStep="curStep > 1 ? true : false"
        @pre="curStep = curStep - 1"
        @new="toNew"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <template v-slot:tools-main>
      <newApprovalDialog
        :show="showNewApprovalDialog"
        @close="showNewApprovalDialog = false"
        :allNode="NodeList"
        @onNew="onNewNode"
        :table="approvalData.business_data_table_name"
      />
      <editApprovalDialog
        :show="showEditApprovalDialog"
        @close="
          showEditApprovalDialog = false;
          NodePropertyData = null;
          curNumber = null;
        "
        :allNode="NodeList.filter((ele) => ele['number'] <= Number(curNumber))"
        :PropertyData="NodePropertyData"
        @onEdit="onEditNode"
        :table="approvalData.business_data_table_name"
      />
    </template>
  </ContentLayout>
</template>
<script>
import newApprovalDialog from "@/Page/EssAdmin/Approval/Approval/components/newApprovalDialog.vue";
import editApprovalDialog from "@/Page/EssAdmin/Approval/Approval/components/editApprovalDialog.vue";

import { mapGetters } from "vuex";
import draggable from "vuedraggable";
export default {
  name: "addApproval",
  components: {
    newApprovalDialog,
    editApprovalDialog,
    draggable,
  },
  computed: {
    ...mapGetters(["companyLang", "staticZone", "defaultUTC"]),
  },
  watch: {},
  mounted() {
    this.approvalData.flow_template_name = this.$getCommonLangKey(
      this.companyLang
    );
    this.approvalData.flow_template_description = this.$getCommonLangKey(
      this.companyLang
    );
    this.approvalData.effective_time_zone = this.defaultUTC;
    this.approvalData.expired_time_zone = this.defaultUTC;
    this.getTableName();
    this.getApprovalType();
  },
  data() {
    return {
      step: 2,
      isChanged: false,
      dragArr: [],
      NodeList: [],
      NodePropertyData: null,
      stepper: [
        "label_essweb_approvalTemplate_form_step_generalLabel",
        "label_essweb_approvalTemplate_form_step_addNodeLabel",
      ],
      curStep: 1,
      curId: null,
      Tables: [],
      curNumber: null,
      approvalType: [],
      approvalData: {
        flow_template_status: 1,
        flow_template_name: "",
        flow_template_description: "",
        flow_type_uuid: "",
        business_data_table_name: "",
        flow_template_code: "",
        effective_utc_datetime: "",
        effective_time_zone: 0,
        expired_utc_datetime: "",
        expired_time_zone: 0,
        remarks: "",
      },
      showNewApprovalDialog: false,
      showEditApprovalDialog: false,
    };
  },
  methods: {
    toNew: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.NodeList.map((item, index) => {
        // delete item.id;
        // delete item.number;
        if (index == 0) {
          item["is_first_sequence"] = 1;
          item["is_final_sequence"] = 0;
        } else if (index > 0 && index < that.NodeList.length - 1) {
          item["is_first_sequence"] = 0;
          item["is_final_sequence"] = 0;
        } else {
          item["is_first_sequence"] = 0;
          item["is_final_sequence"] = 1;
        }
        if (
          item.ess_workflow_template_node_permission[0].pre_node_approver === ""
        ) {
          item.ess_workflow_template_node_permission[0].pre_node_approver =
            null;
        }
        if (
          item.ess_workflow_template_node_permission[0]
            .pre_node_approver_leader === ""
        ) {
          item.ess_workflow_template_node_permission[0].pre_node_approver_leader =
            null;
        }
        if (
          item.ess_workflow_template_node_permission[0].cc_pre_node_approver ===
          ""
        ) {
          item.ess_workflow_template_node_permission[0].cc_pre_node_approver =
            null;
        }
        if (
          item.ess_workflow_template_node_permission[0]
            .cc_pre_node_approver_leader === ""
        ) {
          item.ess_workflow_template_node_permission[0].cc_pre_node_approver_leader =
            null;
        }
      });
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_templates",
        url: "/approval-template/add-approval-template-table/",
        data: {
          flow_template_name: this.$transCommonLangKey(
            this.approvalData.flow_template_name
          ),
          flow_template_code: this.approvalData.flow_template_code,
          flow_template_description: this.$transCommonLangKey(
            this.approvalData.flow_template_description
          ),
          flow_template_status: this.approvalData.flow_template_status ? 1 : 0,
          flow_type_uuid: this.approvalData.flow_type_uuid,
          business_data_table_name: this.approvalData.business_data_table_name,
          effective_utc_datetime: this.$getTimeValue(
            this.approvalData.effective_utc_datetime
          ),
          // effective_time_zone: this.approvalData.expired_time_zone,//BJ
          expired_utc_datetime: this.$getTimeValue(
            this.approvalData.expired_utc_datetime
          ),
          // expired_time_zone: this.approvalData.expired_time_zone,BJ
          ess_workflow_flow_template_nodes: this.NodeList,
          remarks: this.approvalData.remarks,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
    getApprovalType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_type",
        url: "/approval-type/get-approval-type-list/",
      }).then((res) => {
        res.data.map((item) => {
          item.flow_type_name = that.$getCommonLangValue(item.flow_type_name);
        });
        that.approvalType = res.data;
      });
    },
    toDeleteNode: function (obj) {
      const that = this;
      this.curId = obj.number;
      this.$confirmDo(
        this.$t("label_essweb_approvalTemplate_form_nodeLabel")
      ).then((res) => {
        if (res) that.onDeleteNode();
      });
    },
    onDeleteNode: function () {
      const that = this;
      this.NodeList = this.NodeList.filter((ele) => ele.number !== that.curId);
    },
    toEditNode: function (obj, index) {
      if (!obj["number"]) obj["number"] = index;
      this.curNumber = obj["number"];
      this.NodePropertyData = obj;
      this.showEditApprovalDialog = true;
    },
    onNewNode: function (obj) {
      this.showNewApprovalDialog = false;
      this.NodeList.push(obj);
    },
    onEditNode: function (obj) {
      const that = this;
      this.NodeList.map((item, index) => {
        if (item.number == obj.number) {
          that.NodeList.splice(index, 1, obj);
        }
      });
      this.showEditApprovalDialog = false;
    },
    getTableName: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_approval_business_table_select",
        table_type: 1,
      }).then((res) => {
        that.Tables = res.data;
      });
    },
    toNext: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.curStep = this.curStep + 1;
    },
  },
};
</script>
